// test
// export const ZOOP_MARKETPLACE = "3249465a7753536b62545a6a684b0000" // test
export const ZOOP_MARKETPLACE = "29e161cb234449aab377cb1422144c2c" // produção
// export const ZOOP_ZPK = "zpk_test_EzCkzFFKibGQU6HFq7EYVuxI"
export const ZOOP_ZPK = "zpk_prod_hkfbubw316oEhEUkUGMdEXCo"

// export const GQL_ENDPOINT = "https://www.atos6.com/graphql?a6-adm-donation-config"
// export const GQL_ENDPOINT = "https://run.mocky.io/v3/f64e8a18-757d-4050-b0cb-b0a2f4a248e4"
// 85228650aaaa457aa03def2e49f7766f
// 3a12959569a140b39469841a65a33288 // bruno
// export const AUTH_TOKEN = "fa76249b3ac345198ace2d526a6b6895" // neves
// 6554 sem onlineContributionConfiguration
// 9999 não existe
// 5589 imeg
// 2076 Samuel CPF
// 1592 Minha Igreja
// export const ORGANIZATION_ID = "6556"
// export const ORGANIZATION_ID = "1592"

export const ENV = {
  ZOOP_MARKETPLACE,
  ZOOP_ZPK,
  GQL_ENDPOINT: "",
  AUTH_TOKEN: "",
  ORGANIZATION_ID: "",
}
